import { render, staticRenderFns } from "./InventoryReporting.vue?vue&type=template&id=5c5c6c50&scoped=true"
import script from "./InventoryReporting.vue?vue&type=script&lang=js"
export * from "./InventoryReporting.vue?vue&type=script&lang=js"
import style0 from "./InventoryReporting.vue?vue&type=style&index=0&id=5c5c6c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c6c50",
  null
  
)

export default component.exports